/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseTestDto } from '../../models/response-test-dto';

export interface TestsControllerFindOne$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Test ID
 */
  id: string;
}

export function testsControllerFindOne(http: HttpClient, rootUrl: string, params: TestsControllerFindOne$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseTestDto>> {
  const rb = new RequestBuilder(rootUrl, testsControllerFindOne.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseTestDto>;
    })
  );
}

testsControllerFindOne.PATH = '/thalea-pathways/tests/{tenant}/{id}';
